import { useTranslation } from 'react-i18next'; // استيراد للترجمات
import Link from '../ui/Link'; // أو react-router-dom حسب الـ framework
import Line from '../ui/Line'; // افترض إن Line component موجود

const Footer = () => {
  const { t, i18n } = useTranslation(); // استخدام namespace 'footer'

  return (
    <footer
      className="w-full bg-black text-white mt-[268px]"
      role="contentinfo"
      dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} // دعم RTL للعربية (اختياري - عدل حسب إعداداتك)
    >
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
        <div className="flex flex-col gap-8 lg:gap-12">
          {/* Main Footer Content */}
          <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-12">
            {/* Brand Section */}
            <div className="flex flex-col items-start w-full lg:w-1/4 gap-4">
              <div className="flex items-center gap-2">
                <img
                  src="/images/img_black_and_yellow_28x56.png"
                  alt={t('logoAlt')}
                  className="w-[56px] h-[28px]"
                />
                <span className="text-sm font-semibold text-[#d5dbe3]">
                  {t('brand.name')} {/* StarMart - غير مترجم */}
                </span>
              </div>
              <p className="text-base text-[#bdbdbd] leading-relaxed mt-4">
                {t('brand.description')}
              </p>
              <div className="flex items-center justify-between w-full max-w-[200px] mt-8 gap-4">
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.facebook')}
                  className=""
                >
                  <img
                    src="/images/img_vector_white_a700.svg"
                    alt={t('social.facebook')}
                    className="w-[24px] h-[20px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.twitter')}
                  className=""
                >
                  <img
                    src="/images/img_vector_white_a700_18x20.svg"
                    alt={t('social.twitter')}
                    className="w-[20px] h-[18px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.instagram')}
                  className=""
                >
                  <img
                    src="/images/img_152815.svg"
                    alt={t('social.instagram')}
                    className="w-[18px] h-[18px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.linkedin')}
                  className=""
                >
                  <img
                    src="/images/img_vector_white_a700_20x20.svg"
                    alt={t('social.linkedin')}
                    className="w-[20px] h-[20px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.youtube')}
                  className=""
                >
                  <img
                    src="/images/img_vector_white_a700_20x26.svg"
                    alt={t('social.youtube')}
                    className="w-[26px] h-[20px]"
                  />
                </Link>
              </div>
            </div>

            {/* Links Sections */}
            <div className="flex flex-col sm:flex-row justify-between w-full lg:w-3/4 gap-8 lg:gap-12">
              {/* About Section */}
              <div className="flex flex-col gap-4 w-full sm:w-1/3">
                <h3 className="text-base font-semibold text-white">{t('about.title')}</h3>
                <ul className="flex flex-col gap-3" role="list">
                  <li>
                    <Link
                      href="/contact"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('about.contactUs')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/about"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('about.aboutUs')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/careers"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('about.careers')}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Help Section */}
              <div className="flex flex-col gap-4 w-full sm:w-1/3">
                <h3 className="text-base font-semibold text-white">{t('help.title')}</h3>
                <ul className="flex flex-col gap-3" role="list">
                  <li>
                    <Link
                      href="/payment"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('help.payment')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/shipping"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('help.shipping')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/returns"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('help.returnOrder')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/faq"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('help.faq')}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Policies Section */}
              <div className="flex flex-col gap-4 w-full sm:w-1/3">
                <h3 className="text-base font-semibold text-white">{t('policies.title')}</h3>
                <ul className="flex flex-col gap-3" role="list">
                  <li>
                    <Link
                      href="/privacy"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.privacy')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/security"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.security')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/terms"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.terms')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/seller"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.seller')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/refund"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.refund')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/shipping-policy"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#d5dbe3] hover:text-white transition-colors"
                    >
                      {t('policies.shippingPolicy')}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Quick Links Section */}
              <div className="flex flex-col gap-4 w-full sm:w-1/3">
                <h3 className="text-base font-semibold text-[#f9f9f9]">{t('quickLinks.title')}</h3>
                <ul className="flex flex-col gap-3" role="list">
                  <li>
                    <Link
                      href="/privacy-policy"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#f9f9f9] hover:text-white transition-colors"
                    >
                      {t('quickLinks.privacyPolicy')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/terms-of-use"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#f9f9f9] hover:text-white transition-colors"
                    >
                      {t('quickLinks.termsOfUse')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/faq"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#f9f9f9] hover:text-white transition-colors"
                    >
                      {t('quickLinks.faq')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/contact"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel="noopener"
                      onClick={() => {}}
                      aria-label=""
                      className="text-sm text-[#f9f9f9] hover:text-white transition-colors"
                    >
                      {t('quickLinks.contact')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Download App Section */}
            <div className="flex flex-col gap-6 w-full lg:w-1/5">
              <div className="flex flex-col gap-4">
                <h3 className="text-xl font-medium text-[#f9f9f9]">{t('downloadApp.title')}</h3>
                <div className="flex flex-col gap-2">
                  <p className="text-xs text-[#f9f9f9b2] font-medium">{t('downloadApp.offer')}</p>
                  <div className="flex items-center gap-2">
                    <div className="bg-black p-2 rounded">
                      <img
                        src="/images/img_qrcode_1.png"
                        alt={t('downloadApp.qrAlt')}
                        className="w-[76px] h-[76px]"
                      />
                    </div>
                    <div className="flex flex-col gap-1">
                      <Link
                        href="#"
                        variant="default"
                        size="medium"
                        target="_self"
                        rel="noopener"
                        onClick={() => {}}
                        aria-label=""
                        className="block"
                      >
                        <img
                          src="/images/img_png_transparent.png"
                          alt={t('downloadApp.googlePlayAlt')}
                          className="w-[104px] h-[30px] rounded"
                        />
                      </Link>
                      <Link
                        href="#"
                        variant="default"
                        size="medium"
                        target="_self"
                        rel="noopener"
                        onClick={() => {}}
                        aria-label=""
                        className="block"
                      >
                        <img
                          src="/images/img_download_appstore.png"
                          alt={t('downloadApp.appStoreAlt')}
                          className="w-[104px] h-[34px] rounded"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Media Icons (التكرار - استخدم نفس keys) */}
              <div className="flex items-center gap-4">
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.facebook')}
                  className=""
                >
                  <img
                    src="/images/img_icon_facebook.svg"
                    alt={t('social.facebook')}
                    className="w-[24px] h-[24px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.twitter')}
                  className=""
                >
                  <img
                    src="/images/img_icon_twitter.svg"
                    alt={t('social.twitter')}
                    className="w-[24px] h-[24px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.instagram')}
                  className=""
                >
                  <img
                    src="/images/img_icon_instagram.svg"
                    alt={t('social.instagram')}
                    className="w-[24px] h-[24px]"
                  />
                </Link>
                <Link
                  href="#"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label={t('social.linkedin')}
                  className=""
                >
                  <img
                    src="/images/img_icon_linkedin.svg"
                    alt={t('social.linkedin')}
                    className="w-[24px] h-[24px]"
                  />
                </Link>
              </div>
            </div>
          </div>

          {/* Divider Line */}
          <Line width="100%" height="1px" color="#676767" style={{}} className="my-6" />

          {/* Bottom Footer */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            <p className="text-sm font-semibold text-[#d5dbe3]">
              {t('bottom.copyright')}{' '}
           
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 lg:gap-8">
              <div className="flex flex-wrap items-center gap-4 lg:gap-8">
                <Link
                  href="/seller-registration"
                  variant="default"
                  size="medium"
                  target="_self"
                  rel="noopener"
                  onClick={() => {}}
                  aria-label=""
                  className="text-sm font-semibold text-[#d5dbe3] hover:text-white transition-colors"
                >
                  {t('bottom.sellerRegistration')}
                </Link>
              </div>

              <div className="bg-[#191919] p-2 rounded">
                <img
                  src="/images/img_path3789.svg"
                  alt="Payment Methods"
                  className="w-[66px] h-[22px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
